export default "__VITE_ASSET__Ce311Ape__"